import { DashboardAssistantEvent } from "@t3tools/contracts";
import { Option, Schema } from "effect";

import type { DashboardAssistantTimelineItem } from "./dashboardAssistantThread";

export type { DashboardAssistantTimelineItem };

const decodeEvent = Schema.decodeUnknownOption(DashboardAssistantEvent);

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Reads the saved thread. A line this version can't read (saved by a newer
 * assistant) is skipped, so one odd line never hides the rest of the thread.
 */
export function decodeDashboardAssistantTimeline(
  body: unknown,
): ReadonlyArray<DashboardAssistantTimelineItem> {
  const lines = isRecord(body) && Array.isArray(body.timeline) ? body.timeline : [];
  const items: DashboardAssistantTimelineItem[] = [];
  for (const line of lines) {
    if (!isRecord(line)) continue;
    if (line.kind === "user" && typeof line.turnId === "string" && typeof line.text === "string") {
      items.push({ kind: "user", turnId: line.turnId, text: line.text });
    } else if (line.kind === "event") {
      const event = decodeEvent(line.event);
      if (Option.isSome(event)) items.push({ kind: "event", event: event.value });
    }
  }
  return items;
}
